module.exports = __webpack_public_path__ + "static/media/MRII.5c163f5e.jpg";